<mat-card>
  <mat-card-title>No tiene permisos para acceder a la aplicación</mat-card-title>
  <mat-card-content>La cuenta seleccionada no tiene permisos para acceder a la aplicación. Si cree que es un error puede solicitar la verificación con su jefe inmediato.</mat-card-content>
  <mat-card-actions align="end">
    <a mat-raised-button color="primary" target="_self" href="/ingreso-externo?provider=OpenIdConnect"><mat-icon>account_circle</mat-icon> Ingresar con otra cuenta de google</a>
  </mat-card-actions>
</mat-card>
